import { getTheme, Stack } from "@fluentui/react";
import { CommandBar } from "@fluentui/react/lib/CommandBar";
import { useEffect, useState } from "react";

import { contractsCache } from "./buildMenu/actions/build-contract-status-actions";
import { buildMenu } from "./buildMenu/build-menu";
import { MenuProps } from "./buildMenu/interfaces/build-menu";
import { contentStyles } from "./styles";

import { ContractsService } from "@/core/libs/api";
import { useGetProfile } from "@/core/libs/api/react-query/index";
import {
  ContractBadgeColors,
  ContractFlags,
  TranslatedContractCurrentStep
} from "@/modules/Contracts/enums";
import { Badge } from "@/modules/Contracts/styles";
import { ServicesCategoriesTypesEnum } from "@/modules/Settings/types/ServicesCategories.types";

export function ViewMenu({
  contract,
  nextStep,
  action,
  setIsVisible,
  setIsContractOccurrencesDrawerVisible,
  setAction,
  setActionMessage,
  toggleActionModal,
  contractId,
  isButtonDisabled
}: MenuProps): JSX.Element {
  const theme = getTheme();
  const userProfile = useGetProfile();
  const permissions = userProfile.data?.data?.role.permissions;
  const [contractStatus, setContractStatus] = useState(null);
  const [isDownloadingContract, setIsDownloadingContract] =
    useState<boolean>(false);

  useEffect(() => {
    if (contract.serviceCategory.type === ServicesCategoriesTypesEnum.TAG) {
      const contractsThatCannotBeCanceled = async () => {
        const service = ContractsService();
        const { signal } = new AbortController();
        const { data } = await service.getContractsThatCannotBeCanceled({
          signal
        });
        setContractStatus(data);
      };
      contractsThatCannotBeCanceled();
      contractsCache.push(contractStatus);
    }
  }, []);

  return (
    <Stack
      className={contentStyles.stackContainer}
      tokens={{ childrenGap: 10 }}
      horizontal
      verticalAlign="center"
    >
      <div>
        <h2 className="ms-fontSize-24">Contrato #{contract.id}</h2>
      </div>

      <Stack
        className={contentStyles.badgeContainer}
        horizontal
        wrap
        tokens={{ childrenGap: 10 }}
      >
        <Stack.Item styles={{ root: { marginLeft: 10 } }}>
          <Badge
            bgColor={ContractBadgeColors[contract?.currentStep?.internalName]}
          >
            {nextStep?.friendlyName ??
              TranslatedContractCurrentStep[
                contract?.currentStep?.internalName
              ]}
          </Badge>
        </Stack.Item>

        {contract?.flag && contract.flag !== ContractFlags.REGULAR && (
          <Stack.Item styles={{ root: { marginLeft: 10 } }}>
            <Badge bgColor={theme.semanticColors.severeWarningIcon}>
              {ContractFlags[contract.flag]}
            </Badge>
          </Stack.Item>
        )}
      </Stack>

      <div className={contentStyles.commandBarContainer}>
        <CommandBar
          items={buildMenu({
            contract,
            permissions,
            nextStep,
            setIsVisible,
            setIsContractOccurrencesDrawerVisible,
            action,
            toggleActionModal,
            setAction,
            setActionMessage,
            contractId,
            isButtonDisabled,
            isDownloadingContract,
            setIsDownloadingContract
          })}
          styles={{
            root: {
              padding: 0
            }
          }}
        />
      </div>
    </Stack>
  );
}
